import { render, staticRenderFns } from "./NextDelivery.vue?vue&type=template&id=22ad0c1b&scoped=true&"
import script from "./NextDelivery.vue?vue&type=script&lang=js&"
export * from "./NextDelivery.vue?vue&type=script&lang=js&"
import style0 from "./NextDelivery.vue?vue&type=style&index=0&id=22ad0c1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad0c1b",
  null
  
)

export default component.exports